import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=23dd029a&scoped=true"
import script from "./news-list.vue?vue&type=script&lang=js"
export * from "./news-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd029a",
  null
  
)

export default component.exports